import React, {
  Dispatch,
  useEffect,
  useMemo,
  useReducer,
  useState,
} from "react"
import { get } from "lodash"
import uuid from "uuid/v4"
import { useSelector } from "react-redux"

import APIs from "redux/apis"
import { APIResponse } from "redux/apis/types"
import store from "redux/store"
import { LoadStateType, pageLoadRegist } from "redux/ducks/PageLoad"

type UseRegisterSymbolStateType = {
  SecurityType?: string | number
  Symbol?: string | number
  Exchange?: string | number
}

export type UseRegisterSymbolActionType = {
  type: "SET_SYMBOL_DETAIL"
  symbol: {
    SecurityType: string | number
    Symbol: string | number
    Exchange: string | number
  }
}

type ReturnType = (
  effect?: any
) => [APIResponse.Res, Dispatch<UseRegisterSymbolActionType>]

const useRegisterSymbolReducer = (
  state: UseRegisterSymbolStateType,
  action: UseRegisterSymbolActionType
) => {
  switch (action.type) {
    case "SET_SYMBOL_DETAIL":
      return action.symbol
    default:
      return state
  }
}

export const useRegisterSymbolData: ReturnType = effect => {
  const loadingId = useMemo(() => uuid(), [])
  const isPageLoading = useSelector(
    (state: { PageLoad: LoadStateType }) => state.PageLoad.load
  )
  const [state, action] = useReducer(useRegisterSymbolReducer, {
    SecurityType: null,
    Symbol: null,
    Exchange: null,
  })
  const [data, setData] = useState<APIResponse.Res>(null)

  const load = async () => {
    if (state.Symbol && state.Exchange && state.SecurityType) {
      await store.dispatch(pageLoadRegist(loadingId, true))
      const res = await APIs.SymbolDetail.SymbolDetail({
        SecurityType: state.SecurityType,
        Exchange: state.Exchange,
        Symbol: state.Symbol,
      })
      if (get(res, "Result") === 0) setData(res)
      await store.dispatch(pageLoadRegist(loadingId, false))
    }
  }
  useEffect(() => {
    load()
  }, [state, effect])

  useEffect(() => {
    if (isPageLoading) load()
  }, [isPageLoading])
  return [data, action]
}
